// extracted by mini-css-extract-plugin
module.exports = {"launchGRDLuxury":"style_launchGRDLuxury__hFghI","luxuryGRDBlock":"style_luxuryGRDBlock__3Kllm"};